









import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { maximumAmountCurrency } from '@/utils/utils';

@Component
export default class BoxRoomBaseRate extends Vue {
  @Prop({ required: true, default: 0 }) public initialAmount!: number;
  @Prop({ required: true }) public readonly roomId!: string;
  @Prop({ required: true }) public readonly date!: string;
  @Prop({ required: true }) public readonly disabled!: boolean;
  @Prop({ required: true }) public readonly currencyCode!: string;

  public isEditingPrice: boolean = false;
  public amountNumber: number = this.initialAmount;
  public amount: string = this.displayPrice(this.initialAmount);
  public prevAmountNumber: number = this.amountNumber;
  public maxAmount = maximumAmountCurrency[this.currencyCode];
  public isLoading: boolean = false;
  public inputShown: boolean = false;
  public errorInput: boolean = false;

  get dropdownRoomStatus() {
    return this.$store.state.dashboard.dropdownRoomStatus.show;
  }

  get partnerId() {
    return this.$store.state.partner.id;
  }

  get formattedPrice() {
    return this.amountFromFormatted ? this.displayPrice(this.amountFromFormatted) : '-';
  }

  get amountFromFormatted() {
    const amountArr = this.amount.split(/[,.]/);
    return Math.round(Number(amountArr.join('.')) * 100);
  }

  get isSaturday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '6';
  }

  get isMonday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '1';
  }

  public displayPrice(price: number): string {
    const separator = this.$store.getters.separator;
    return price % 100 === 0 ?
        String(price / 100).split('.').join(separator) :
        String((price / 100).toFixed(2)).split('.').join(separator);
  }

}
